<template>
  <div class="row">
    <div
      v-for="item in items"
      :key="item.id"
      class="col-lg-4 col-md-6 wow move-up"
    >
      <div class="service-grid">
        <div class="ht-service-box--two text-center style-03">
          <router-link to="">
            <div class="image mb-20">
              <img
                :src="item.icon"
                class="img-fluid"
                alt="aeroland-startup-box-icon-01"
              />
            </div>
            <div class="content">
              <h6 class="heading">{{ item.heading }}</h6>
              <div class="service_text">{{ item.text }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StartUpFeatureTwo",
  data() {
    return {
      items: [
        {
          icon: require("../assets/img/icons/aeroland-startup-box-icon-01.png"),
          heading: "OUTPUT AUTOMATION",
          text:
            "Auto-Generate Substantive Legal Documents from data at the click of a button."
        },
        {
          icon: require("../assets/img/icons/aeroland-startup-box-icon-02.png"),
          heading: "CLIENT ENGAGEMENT",
          text:
            "Send clients forms and get verified responses to discovery. Send links to upload records and evidence."
        },
        {
          icon: require("../assets/img/icons/aeroland-startup-box-icon-03.png"),
          heading: "HIRE EXPERTS",
          text:
            "Hire experts and thrid-party service providers from within your case file at the click of a button."
        },
        {
          icon: require("../assets/img/icons/aeroland-startup-box-icon-04.png"),
          heading: "E-DEPOSITION",
          text:
            "Perform your entire deposition from notice to transcript completely in-app. No other tools necessary."
        },
        {
          icon: require("../assets/img/icons/aeroland-startup-box-icon-04.png"),
          heading: "E-MEDIATION",
          text:
            "Perform your entire mediation from brief to settlement completely in-app."
        },

        {
          icon: require("../assets/img/icons/aeroland-startup-box-icon-06.png"),
          heading: "MED-LEGAL LIASSON",
          text:
            "Get treatment for your clients, get medical records, and settle liens completely in-app."
        }
      ]
    };
  }
};
</script>
